import { getMyWorkspaces } from '@services/external/user.api';
import { GetMyWorkspacesParams } from 'types/workspace.types';
import { useAppSelector } from './../../app/redux';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

async function handler(providerId: string, params: GetMyWorkspacesParams) {
  const { data } = await getMyWorkspaces(providerId, params);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useMyWorkspaces(
  params: GetMyWorkspacesParams = {},
  options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['provider:myWorkspaces', providerId, params],
    () => handler(providerId, params),
    options,
  );
}

export default useMyWorkspaces;
